module.exports = {
  FALSE_VALUE: false,
  CORRECT_BOOL_VALUE: 'Good, false meant false.  We did not cast a boolean to a string.',
  INCORRECT_BOOL_VALUE: 'Why was a false boolean true?',
  INTEGER_VALUE: 123,
};
